import { getAdminAxiosInstance } from '../../../api/Admin';

export const createOfficeDelivery = async (params) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`/office-delivery/store`, params);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteOfficeDelivery = async (id) => {
  const api = await getAdminAxiosInstance();

  try {
    const response = await api.delete(`/office-delivery/delete?id=${id}`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};